import CardWrapper from '../card-wrapper';
import Step05Image from '../../../../../assets/images/memory/onboarding/step-05-02.svg';
import { Typography } from '../../../../../core/components/molecules/Typography';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';

const Step05C = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex w-full flex-col items-start justify-center gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            Iniciando uma Revisão
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Revisão
          </Typography>
          <Typography className='flex flex-col gap-4 !text-md !font-normal text-mono-color-darker'>
            <span>
              Ao iniciar uma revisão, você poderá testar seus conhecimentos e
              memorização.
            </span>
            <span>
              Você verá o nome do Deck, logo em seguida a frente do cartão com a
              pergunta.
            </span>
          </Typography>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[438px] w-[554px]'>
        <img
          src={Step05Image}
          alt='Step 05-C'
          className='h-full w-full rounded-lg md:object-cover'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step05C;
